import { render, staticRenderFns } from "./ArrangeSections.vue?vue&type=template&id=d57624e6&scoped=true"
import script from "./ArrangeSections.vue?vue&type=script&lang=js"
export * from "./ArrangeSections.vue?vue&type=script&lang=js"
import style0 from "./ArrangeSections.vue?vue&type=style&index=0&id=d57624e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57624e6",
  null
  
)

export default component.exports